import React from 'react';
import {
  Box,
  Dropdown,
  DropdownOverlay,
  SelectInput,
  ActionList,
  ActionListItem,
} from '@razorpay/blade/components';
import { PFWageCalculationType } from 'api/employeeOnboarding';
import { RegisterGenericType } from 'forms/useRegister';

const pfWageCalculationTypes: Array<{
  title: string;
  value: PFWageCalculationType;
}> = [
  {
    title: 'Use Company Default',
    value: 'default',
  },
  {
    title: 'Use ₹15,000 Limit',
    value: '15k',
  },
  {
    title: 'No Limit',
    value: 'no_limit',
  },
];

export const PFWageCalculationSelectInput = ({
  registerFormData,
}: {
  registerFormData: RegisterGenericType<{ pfWagesCalculationType: PFWageCalculationType[] }>;
}) => {
  return (
    <Box>
      <Dropdown selectionType="single">
        <SelectInput
          label="PF Wage Calculation"
          labelPosition="top"
          {...registerFormData('pfWagesCalculationType', 'select')}
          isRequired
          necessityIndicator="required"
        />
        <DropdownOverlay>
          <ActionList>
            {pfWageCalculationTypes.map((type) => (
              <ActionListItem key={type.value} title={type.title} value={type.value} />
            ))}
          </ActionList>
        </DropdownOverlay>
      </Dropdown>
    </Box>
  );
};
